
import { Button } from "@/components/ui/button";
import { SheetClose } from "@/components/ui/sheet";
import { FilterState } from "../types/filter-types";
import TopPerformersFilter from "./TopPerformersFilter";
import InvestmentFilter from "./InvestmentFilter";
import ExchangeFilter from "./ExchangeFilter";
import StrategyTypeFilter from "./StrategyTypeFilter";

interface FilterSidebarProps {
  filters: FilterState;
  setFilters: (filters: FilterState) => void;
  topPerformers: boolean;
  setTopPerformers: (value: boolean) => void;
  toggleExchange: (exchange: string) => void;
  toggleRiskLevel: (level: string) => void;
  toggleStrategyType: (type: "premium" | "free") => void;
}

const FilterSidebar = ({
  filters,
  setFilters,
  topPerformers,
  setTopPerformers,
  toggleExchange,
  toggleStrategyType,
}: FilterSidebarProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-[#1B2F47] mb-4">
          Refine Your Strategy Search
        </h2>
      </div>

      <TopPerformersFilter
        checked={topPerformers}
        onCheckedChange={(checked) => setTopPerformers(checked)}
      />

      <div className="space-y-6">
        <InvestmentFilter
          value={filters.minInvestment}
          onChange={(value) => setFilters({ ...filters, minInvestment: value })}
        />

        <ExchangeFilter
          selectedExchanges={filters.exchange}
          onToggle={toggleExchange}
        />

        <StrategyTypeFilter
          selectedTypes={filters.strategyTypes}
          onToggle={toggleStrategyType}
        />
      </div>

      <SheetClose asChild>
        <Button 
          className="w-full bg-[#007BFF] hover:bg-[#0056b3] text-white mt-8"
        >
          Apply Filters
        </Button>
      </SheetClose>
    </div>
  );
};

export default FilterSidebar;
